import { render } from "./EmailNotificationShow.vue?vue&type=template&id=63cbacee&scoped=true"
import script from "./EmailNotificationShow.vue?vue&type=script&lang=js"
export * from "./EmailNotificationShow.vue?vue&type=script&lang=js"

import "./EmailNotificationShow.vue?vue&type=style&index=0&id=63cbacee&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cbacee"]])

export default __exports__